export default __webpack_public_path__ + "static/media/left_hero_like.4e90804e.png";